export type ActionType =
    | "edit"
    | "copy"
    | "related"
    | "bindings"
    | "task"
    | "print"
    | "email"
    | "delete"
    | "create"
    | "ownership"
    | "subscribe";

export interface MoreActionsMenu {
    selectAction(view?: ActionType): void;
}

export class MoreActionsService {
    private static instances: MoreActionsMenu[] = [];

    public static register(instance: MoreActionsMenu) {
        MoreActionsService.instances.push(instance);
    }

    public static unregister(instance: MoreActionsMenu) {
        MoreActionsService.instances = MoreActionsService.instances.filter((inst) => inst !== instance);
    }

    public static open(view?: ActionType) {
        MoreActionsService.instances.forEach((inst) => inst.selectAction(view));
    }
}
